import { useEffect, useState } from "react";
import { processGet } from "../../../../../services/api";

export const AccessModal = (props: any) => {
  const id = props.id;
  const [users, setUsers] = useState([]);
  const onSelect = props.onSelect ? props.onSelect : () => {}
  useEffect(() => {
    const fetchUser = async () => {
      if(id){
        let users:any = await processGet('tenants/'+id+'/users');
        setUsers(users.data)
      }
    }

    fetchUser()
  }
  , [id])
  return (<>
    <label>Scegli l'utente da impersonificare</label>
    <select  onChange={onSelect} className="form-select">
      <option>Seleziona un utente</option>
      {users.map((user:any) => {
        return <option key={user.userId} value={user.userId}>{user.name} - {user.email}({user.role})</option>
      })}
    </select>
  </>)
}